/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Menu } from '../../models/menu';
import { MenuApiRespModel } from '../../models/menu-api-resp-model';

export interface ApiMasterMenuEditPost$Params {
      body?: Menu
}

export function apiMasterMenuEditPost(http: HttpClient, rootUrl: string, params?: ApiMasterMenuEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<MenuApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterMenuEditPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MenuApiRespModel>;
    })
  );
}

apiMasterMenuEditPost.PATH = '/api/Master/Menu/Edit';
